jQuery(document).ready(function ($) {
    var productVariations = $('.product__variations');
    var resetButton = $('.variations-form__reset');
    var singleVariation = $('.single_variation'); // Select the single_variation element
    var crossSellsRow = $('.cross-sells__row'); // Select the cross-sells__row element

    if (productVariations.length) {
        var selects = productVariations.find('select');

        // Initially hide the reset button and single_variation
        singleVariation.css('display', 'none');

        selects.each(function (index) {
            if (index !== 0) {
                $(this).prop('disabled', true);
            }

            $(this).on('change', function () {
                // Enable the next select if an option is selected
                if ($(this).val() && index < selects.length - 1) {
                    $(selects[index + 1]).prop('disabled', false);
                }

                // Check if the current select is set back to the default option
                if (!$(this).val()) {
                    // Reset all selects after the current one and disable them
                    selects.each(function (i) {
                        if (i > index) {
                            $(this).val('').prop('disabled', true);
                            // Remove the 'cross-sells__row--active' class from 'cross-sells__row'
                            crossSellsRow.removeClass('cross-sells__row--active');
                        }
                    });
                }

    
            });
        });

    }
});
